import axios from 'axios'
import Vue from 'vue'

export async function fetchUrls(context,payload){
    try{
        context.commit('setLoading',true,{root:true}) //activar loading
        let url = "api/geturls" //direccion de la api
        let response = await Vue.axios({
            method: 'GET',
            url: url
        })
        context.commit('setUrls',response.data)
    }catch(error){  
        context.commit('urlsError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}